import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, NONE, UNLIMITED, VALUE, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
    moduleIds,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
    Input,
} from "client/components"

const Cc = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        ccModuleAccess,
        ccAccountComplianceSets,
        ccAccountComplianceSetsValue,
        ccLibraryComplianceSets,
        ccLibraryComplianceSetsValue,
        ccCompliantItems,
        ccCompliantItemsValue,
        ccProjectCompliantItems,
        ccProjectCompliantItemsValue,
        ccResponseModuleAccess,
        ccApprovalModuleAccess,
        ccRequirementsModuleAccess,
        ccRequirements,
        ccRequirementsValue,
    } = settings

    return (
        <Collapse
            show={show}
            title={moduleList[moduleIds.cc].name}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.complianceCaseAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccModuleAccess === NO}
                            onChange={() => onChange({ ccModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={ccModuleAccess === YES}
                            onChange={() => onChange({ ccModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.accountComplianceSets}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccAccountComplianceSets === NONE}
                            onChange={() => onChange({ ccAccountComplianceSets: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={ccAccountComplianceSets === VALUE}
                            onChange={() => onChange({ ccAccountComplianceSets: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={ccAccountComplianceSetsValue}
                                    onChange={(e) => onChange({
                                        ccAccountComplianceSetsValue: parseInt(e.target.value, 10) || 0,
                                    })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={ccAccountComplianceSets === UNLIMITED}
                            onChange={() => onChange({ ccAccountComplianceSets: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.libraryComplianceSets}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccLibraryComplianceSets === NONE}
                            onChange={() => onChange({ ccLibraryComplianceSets: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={ccLibraryComplianceSets === VALUE}
                            onChange={() => onChange({ ccLibraryComplianceSets: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={ccLibraryComplianceSetsValue}
                                    onChange={(e) => onChange({
                                        ccLibraryComplianceSetsValue: parseInt(e.target.value, 10) || 0,
                                    })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={ccLibraryComplianceSets === UNLIMITED}
                            onChange={() => onChange({ ccLibraryComplianceSets: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.compliantItemsPerSet}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccCompliantItems === NONE}
                            onChange={() => onChange({ ccCompliantItems: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={ccCompliantItems === VALUE}
                            onChange={() => onChange({ ccCompliantItems: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={ccCompliantItemsValue}
                                    onChange={(e) => onChange({ ccCompliantItemsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={ccCompliantItems === UNLIMITED}
                            onChange={() => onChange({ ccCompliantItems: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.projectCompliantItemsPerSet}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccProjectCompliantItems === NONE}
                            onChange={() => onChange({ ccProjectCompliantItems: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={ccProjectCompliantItems === VALUE}
                            onChange={() => onChange({ ccProjectCompliantItems: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={ccProjectCompliantItemsValue}
                                    onChange={(e) => onChange({
                                        ccProjectCompliantItemsValue: parseInt(e.target.value, 10) || 0,
                                    })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={ccProjectCompliantItems === UNLIMITED}
                            onChange={() => onChange({ ccProjectCompliantItems: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.responseModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccResponseModuleAccess === NO}
                            onChange={() => onChange({ ccResponseModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={ccResponseModuleAccess === YES}
                            onChange={() => onChange({ ccResponseModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.approvalLevelsAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccApprovalModuleAccess === NO}
                            onChange={() => onChange({ ccApprovalModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={ccApprovalModuleAccess === YES}
                            onChange={() => onChange({ ccApprovalModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.requirementsModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccRequirementsModuleAccess === NO}
                            onChange={() => onChange({ ccRequirementsModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={ccRequirementsModuleAccess === YES}
                            onChange={() => onChange({ ccRequirementsModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.requirements}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={ccRequirements === NONE}
                            onChange={() => onChange({ ccRequirements: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={ccRequirements === VALUE}
                            onChange={() => onChange({ ccRequirements: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={ccRequirementsValue}
                                    onChange={(e) => onChange({ ccRequirementsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={ccRequirements === UNLIMITED}
                            onChange={() => onChange({ ccRequirements: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Cc
